export * from "@vaadin/slider/vaadin-range-slider.js";
export * from './generated/RangeSlider.js';
